export enum DatatableType {
  REGULAR = 'regular',
  COMPACT = 'compact',
}
